import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { formatNumber } from '@progress/kendo-intl';

import * as React from 'react';
import { ViewModel } from '.';

const PayCell = (props: GridCustomCellProps) => {
  const data = props.dataItem as ViewModel;
  return (
    <td {...props.tdProps} style={{ ...props.tdProps?.style, textAlign: 'right' }}>
      {formatNumber(data.TotalPay, 'C')}
    </td>
  );
}
export default React.memo(PayCell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);